/*
 * 規約系ページ（/policies/*）の本文を読みやすい構造に整える。
 * 管理画面のポリシー本文は Word から貼った段落の羅列なので、表示時に
 * 空段落の除去・見出し化・箇条書き化・「項目：内容」の表化・目次の追加を行う。
 * 本文の文言は変えない。見た目は assets/policy-readable.css。
 */
(function () {
  const rte = document.querySelector('.shopify-policy__body .rte');
  if (!rte || rte.dataset.policyReadable) return;
  rte.dataset.policyReadable = 'true';

  const titleEl = document.querySelector('.shopify-policy__title h1');
  const title = titleEl ? titleEl.textContent : '';
  const blank = function (s) { return !s.replace(/[\s ]/g, ''); };
  const norm = function (s) { return s.replace(/[\s ]/g, ''); };
  const each = function (sel, fn) { Array.prototype.slice.call(root.querySelectorAll(sel)).forEach(fn); };

  // 本文が1つの div で囲まれている場合は、その div を基準にする（既存のクラスを壊さない）
  let root = rte;
  if (rte.children.length === 1 && rte.firstElementChild.tagName === 'DIV') root = rte.firstElementChild;

  // 既に見出しタグで書かれているページ（プライバシーポリシー等）は構造に手を入れず、目次だけ付ける
  if (!root.querySelector('h2')) {
    // <br><br> で区切られた段落を分ける
    each('p', function (p) {
      const parts = p.innerHTML.split(/<br>\s*<br>/i);
      if (parts.length < 2) return;
      parts.forEach(function (h) { const n = document.createElement('p'); n.innerHTML = h; p.parentNode.insertBefore(n, p); });
      p.remove();
    });

    // 空行だけの段落を消す
    each('p', function (p) { if (blank(p.textContent) && !p.querySelector('img')) p.remove(); });

    // 太字だけの段落 → 見出し。「太字＋改行＋本文」の段落 → 見出し＋本文
    each('p', function (p) {
      const first = p.firstElementChild;
      if (!first || !/^(STRONG|B)$/.test(first.tagName)) return;
      const head = norm(first.textContent);
      if (!head || head.length > 30 || norm(p.textContent).indexOf(head) !== 0) return;
      const h = document.createElement('h2');
      h.textContent = first.textContent.replace(/[\s ]+/g, ' ').trim().replace(/^＜|＞$/g, '').replace(/[：:]$/, '');
      first.remove();
      p.innerHTML = p.innerHTML.replace(/^\s*<br>/i, '');
      p.parentNode.insertBefore(h, p);
      if (blank(p.textContent)) p.remove();
    });

    // 先頭がページ名と同じ見出しなら消す（h1 と重複するため）
    const h0 = root.querySelector('h2');
    if (h0 && h0 === root.firstElementChild && norm(h0.textContent) === norm(title)) h0.remove();

    // 段落の頭の【〇〇】 → 小見出し
    each('p', function (p) {
      const m = p.innerHTML.match(/^\s*【([^】]{1,20})】\s*(<br>)?/);
      if (!m) return;
      const h = document.createElement('h3');
      h.textContent = m[1];
      p.parentNode.insertBefore(h, p);
      p.innerHTML = p.innerHTML.slice(m[0].length);
      if (blank(p.textContent)) p.remove();
    });

    // 「項目：内容」が改行で2行以上並ぶ段落 → 定義リスト（表）
    const keyLine = /^([^：:。、<0-9０-９]{1,12})[:：]+\s*(.+)$/;
    each('p', function (p) {
      const lines = p.innerHTML.split(/<br>/i).map(function (s) { return s.trim(); })
        .filter(function (s) { return !blank(s.replace(/<[^>]+>/g, '')); });
      if (lines.length < 2 || !keyLine.test(lines[0])) return;
      if (lines.filter(function (l) { return keyLine.test(l); }).length < 2) return;
      const dl = document.createElement('dl');
      let dd = null;
      lines.forEach(function (l) {
        const m = l.match(keyLine);
        if (m) {
          const dt = document.createElement('dt');
          dt.innerHTML = m[1];
          dd = document.createElement('dd');
          dd.innerHTML = m[2];
          dl.appendChild(dt);
          dl.appendChild(dd);
        } else if (dd) {
          dd.innerHTML += '<br>' + l;
        }
      });
      p.parentNode.replaceChild(dl, p);
    });

    // 「・」で始まる段落 → 箇条書き（項目の間に挟まった補足の段落は直前の項目へ入れる）
    const isBullet = function (el) { return el && el.tagName === 'P' && /^・/.test(el.textContent.trim()); };
    let ul = null;
    Array.prototype.slice.call(root.children).forEach(function (el) {
      if (isBullet(el)) {
        if (!ul) { ul = document.createElement('ul'); el.parentNode.insertBefore(ul, el); }
        const li = document.createElement('li');
        li.innerHTML = el.innerHTML.replace(/^(\s|&nbsp;)*・/, '');
        ul.appendChild(li);
        el.remove();
      } else if (ul && el.tagName === 'P' && isBullet(el.nextElementSibling)) {
        ul.lastElementChild.innerHTML += '<br>' + el.innerHTML;
        el.remove();
      } else {
        ul = null;
      }
    });

    // ※で始まる段落 → 注記
    each('p', function (p) { if (/^[※*＊]/.test(p.textContent.trim())) p.classList.add('policy-note'); });
  }

  // 見出しが3つ以上で、本文が長い（1,500字以上）ページだけ目次を付ける
  const hs = Array.prototype.slice.call(root.querySelectorAll('h2'));
  if (hs.length < 3 || norm(root.textContent).length < 1500) return;
  // スマホで項目が多いときは閉じた状態で出す（本文までの距離を縮める）
  const nav = document.createElement('details');
  nav.className = 'policy-toc';
  nav.open = !(hs.length > 8 && window.matchMedia('(max-width: 749px)').matches);
  const summary = document.createElement('summary');
  summary.innerHTML = '<span class="policy-toc__label">目次</span><span class="policy-toc__count">' + hs.length + '項目</span>';
  const ol = document.createElement('ol');
  hs.forEach(function (h, i) {
    if (!h.id) h.id = 'policy-sec-' + (i + 1);
    const text = h.textContent.replace(/[\s ]+/g, ' ').trim();
    const li = document.createElement('li');
    const a = document.createElement('a');
    a.href = '#' + h.id;
    // 「第1条」「1.」などの番号は別の列に分けて揃える
    const m = text.match(/^(第[0-9０-９]+条|[0-9０-９]+[.．])\s*(.+)$/);
    if (m) {
      const num = document.createElement('span');
      num.className = 'policy-toc__num' + (/条$/.test(m[1]) ? '' : ' policy-toc__num--short');
      num.textContent = m[1];
      const body = document.createElement('span');
      body.textContent = m[2];
      a.appendChild(num);
      a.appendChild(body);
    } else {
      a.textContent = text;
    }
    li.appendChild(a);
    ol.appendChild(li);
  });
  nav.appendChild(summary);
  nav.appendChild(ol);
  rte.parentNode.insertBefore(nav, rte);
})();
